import React from 'react'

function Arrow({color}) {
  return (
    <>
        <svg width="28" height="22" viewBox="0 0 28 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M17.0997 21.9805C17.7071 21.9805 17.8553 21.6362 17.4218 21.2027L10.4675 14.2484C10.0378 13.8187 10.1799 13.4705 10.7865 13.4705L26.2365 13.4705C26.8423 13.4705 27.3333 12.9788 27.3333 12.3741L27.3333 9.62594C27.3333 9.02047 26.8431 8.52947 26.2365 8.52947L10.7865 8.52947C10.1806 8.52947 10.0336 8.18519 10.4675 7.75167L17.4218 0.797351C17.8511 0.367665 17.7079 0.0195474 17.0997 0.0195474L12.3111 0.0195478C11.7037 0.0195479 10.8646 0.366136 10.4349 0.796205L1.00745 10.2233C0.578912 10.6522 0.577765 11.3465 1.00745 11.7766L10.4349 21.2037C10.8638 21.6326 11.7029 21.9803 12.3111 21.9803L17.0997 21.9805Z" fill={color ? color : "#4A5A72"}/>
        </svg>
    </>
  )
}

export default Arrow